/**
 * Native store prices (`product.displayPrice` from App Store / Google Play) come
 * pre-formatted for the device locale, always with a 2-digit fraction — e.g.
 * "85,00 ₽", "$85.00", "1.299,00 ₽". For whole-number currencies like RUB that
 * trailing ",00" is visual noise that bloats the tier buttons. Strip the fraction
 * only when it is exactly two zeros not followed by another digit, so thousands
 * separators ("1,000 ₽") and non-zero fractions ("85,50 ₽") are left untouched.
 *
 * Deliberately NOT reconstructed via `Intl.NumberFormat(...stripIfInteger)`: the
 * store already localized this for the device's real region, which we don't know
 * (we only have the app UI language). Reformatting with the app locale degrades
 * mixed cases — e.g. English UI + RUB renders "RUB 299" instead of the native
 * "299 ₽". Trimming the native string keeps the store's superior localization.
 */
export function stripZeroFraction(displayPrice: string): string {
	return displayPrice.replace(/([.,])00(?!\d)/, "")
}

export function priceFontSize(displayPrice: string): number {
	const currency = displayPrice.replace(/[\d\s.,]/g, "")
	if (currency.length >= 3) return 13
	if (currency.length === 2) return 17
	return 22
}
